import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type DeleteReferenceMeasurementPayload = {
  unityID: string;
};

export const useDeleteReferenceMeasurementMutation = (tourId: string) => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();

  const result = useMutation({
    mutationFn: async (payload: DeleteReferenceMeasurementPayload) => {
      const { data } = await authApi.delete(
        `/virtual-tour/reference-measurement/${payload.unityID}`
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["virtual-tour-reference-measurements", tourId],
      });
    },
  });

  return result;
};
